import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 解决两次访问相同路由地址报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: resolve => require(['@/views/home'], resolve),
      meta: {
        theme: 'dark'
      }
    },
    {
      path: '/home/users',
      name: 'Users',
      component: resolve => require(['@/views/home/users'], resolve),
      meta: {
        hideFooter: true
      }
    },
    // 关于普顿
    {
      path: '/about',
      name: 'About',
      component: resolve => require(['@/views/about'], resolve),
      meta: {
        pageName: '关于我们',
        banner: require('../assets/images/banner_about.png')
      }
    },
    {
      path: '/about/group',
      name: 'AboutGroup',
      component: resolve => require(['@/views/about/group'], resolve),
      meta: {
        pageName: '精英顾问团队',
        banner: 'https://www.tencent.com/img/banners/brief-1.jpg',
        activeMenu: '/about',
        apiActiveMenu: '/about/group'
      }
    },
    {
      path: '/about/message',
      name: 'AboutMessage',
      component: resolve => require(['@/views/about/message'], resolve),
      meta: {
        pageName: '总裁寄语',
        banner: require('../assets/images/banner_message.png'),
        activeMenu: '/about',
        apiActiveMenu: '/about/message'
      }
    },
    {
      path: '/about/characteristic',
      name: 'AboutCharacteristic',
      component: resolve => require(['@/views/about/characteristic'], resolve),
      meta: {
        pageName: '普顿教育特色',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg',
        activeMenu: '/about',
        apiActiveMenu: '/about/characteristic'
      }
    },
    // 服务
    {
      path: '/services',
      redirect: '/services/president'
    },
    {
      path: '/services/president',
      name: 'ServicesPresident',
      component: resolve => require(['@/views/services/president'], resolve),
      meta: {
        pageName: '我们的做法',
        banner: 'https://www.tencent.com/img/banners/investor-1.jpg',
        activeMenu: '/services',
        apiActiveMenu: '/services/president'
      }
    },

    // {
    // 	path: '/research',
    // 	name: 'Research',
    // 	component: resolve => require(['@/views/research'], resolve),
    // },

    // {
    // 	path: '/news',
    // 	name: 'News',
    // 	component: resolve => require(['@/views/news'], resolve),
    // },
    // 橙果
    {
      path: '/case',
      name: 'Case',
      component: resolve => require(['@/views/case'], resolve),
      meta: {
        pageName: '我们的口碑',
        banner: require('../assets/images/banner_case.png')
      }
    },
    // 数据
    {
      path: '/results',
      redirect: '/results/summary'
    },
    {
      path: '/results/summary',
      name: 'ResultsSummary',
      component: resolve => require(['@/views/results/summary'], resolve),
      meta: {
        pageName: '我们的录取数据',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg',
        activeMenu: '/results',
        apiActiveMenu: '/results/summary'
      }
    },
    {
      path: '/results/record/:id',
      name: 'ResultsRecord',
      component: resolve => require(['@/views/results/record'], resolve),
      meta: {
        pageName: '录取数据',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg',
        activeMenu: '/results',
        apiActiveMenu: '/results/record/:id'
      }
    },

    // rsi
    {
      path: '/rsi',
      name: 'RSI',
      component: resolve => require(['@/views/rsi'], resolve),
      meta: {
        pageName: 'RSI•MIT申请',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg'
      }
    },
    {
      path: '/rsi/studentsShare',
      name: 'RSIStudentsShare',
      component: resolve => require(['@/views/rsi/studentsShare'], resolve),
      meta: {
        pageName: 'RSI录取学生分享',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg',
        activeMenu: '/rsi',
        apiActiveMenu: '/rsi/studentsShare'
      }
    },
    {
      path: '/rsi/application',
      name: 'RSIApplication',
      component: resolve => require(['@/views/rsi/application'], resolve),
      meta: {
        pageName: 'RSI-MIT申请流程',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg',
        activeMenu: '/rsi',
        apiActiveMenu: '/rsi/application'
      }
    },
    {
      path: '/rsi/dataRecording',
      name: 'RSIDataRecording',
      component: resolve => require(['@/views/rsi/dataRecording'], resolve),
      meta: {
        pageName: 'RSI录取数据',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg',
        activeMenu: '/rsi',
        apiActiveMenu: '/rsi/dataRecording'
      }
    },
    // 联系我们
    {
      path: '/contactUs',
      name: 'ContactUs',
      component: resolve => require(['@/views/contactUs'], resolve),
      meta: {
        pageName: '联系我们',
        banner: 'https://www.tencent.com/img/banners/responsibility-1.jpg'
      }
    },

    // {
    // 	path: '/studyAbroad',
    // 	name: 'StudyAbroad',
    // 	component: resolve => require(['@/views/studyAbroad'], resolve),
    // },

    // 404页面
    {
      path: '*',
      redirect: '/'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js